import { createBrowserHistory } from 'history'
 
const history = createBrowserHistory({
  basname: '',
  forceRefresh: true
})

export default history